/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do button 
 */
export default styled.button`
  color: #bec7dc;
  background: transparent;
  border: none;

  &:hover,
  &.active {
    ${({ activeWithBgColor }) =>
      activeWithBgColor ? 'background: rgba(0, 0, 0, 0.2);' : ''}
  }

  &.disabled {
    opacity: 0.25;
    cursor: not-allowed;

    &:hover {
      background: transparent;
    }
  }
`;
